import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { UtcDateTimeOptions } from '@shared/enums';
import { toUTCDate } from '@shared/utils';

@Pipe({
  name: 'toUtcDateTime',
})
export class ToUtcDateTimePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(date: Date | string, format = 'yyyy.MM.dd HH:mm'): string {
    return (
      this.datePipe.transform(
        toUTCDate(new Date(date), UtcDateTimeOptions.UtcDateWithTime),
        format
      ) || ''
    );
  }
}
